import http from "@/utils/http";
const prefixUrl = {
  hourly: "/Index/detail24hour.html", // API-3
};
export default {
  query(params = {}) {
    return http.get(prefixUrl.hourly, { params });
  },
};
